module.exports = __webpack_public_path__ + "static/Santiago-Jimenez-43e47defc5244e085c31169e18f2326c.png";